import { useQuery } from '@tanstack/vue-query';
import industriesApi from '@/api/industries';

// eslint-disable-next-line import/prefer-default-export
export function useIndustriesQuery() {
  return useQuery(['industries'], () => industriesApi.getAll().then((response) => response.industries));
}
